import { appContext } from "../App/appContext"

export function addApi(url: string): string {
    return `/api${url}`;
}

export function addApiAndUrlParams(url: string): string {
    return addUrlParams(addApi(url));
}

// Add url params like visSom
export function addUrlParams(url: string): string {
    const result = addVisSom(url);
    return result; // copyUrlParams(result, appContext.getCurrentLocation(), ["take", "offset"], false);
}

export function addVisSom(url: string): string {
    const visSom = appContext.visSomAktorId;
    return visSom ? setUrlParam(url, "visSom", `${visSom}`) : url;
}

export function copyUrlParams(url: string, source: string, params: string[], override = true): string {
    return params.reduce((acc, val) => { return copyUrlParam(acc, source, val, override); }, url);
}

export function copyUrlParam(url: string, source: string, param: string, override = true): string {
    const value = getUrlParam(source, param);
    return setUrlParam(url, param, value, override);
}

export function getUrlParam(url: string, param: string): string | undefined {
    const iq = url.indexOf("?");
    if(iq === -1) {
        return undefined;
    }
    const query = url.substring(iq + 1);
    const vars = query.split("&");
    for (let i = 0; i < vars.length; i++) {
        const pair = vars[i].split("=");
        if (decodeURIComponent(pair[0]) === param) {
            return decodeURIComponent(pair[1]);
        }
    }
    return undefined;
}

export function hasUrlParam(url: string,  param: string): boolean {
    const value = getUrlParam(url,  param);
    return !!value && (value.trim().length > 0);
}

export function setUrlParam(url: string, param: string, value?: string, override = true): string {
    const pv = (p: string, v?: string) => v !== undefined ? (p + "=" + encodeURIComponent(v)) : "";
    const sp = (s: string, b: boolean, p: string) => (b ? s : "") + p;
    const iq = url.indexOf("?");
    if(iq === -1) {
        const part = pv(param, value);
        return url + sp("?", !!part, part);
    }
    const query = url.substring(iq + 1);
    let result = url.substring(0, iq + 1);
    const vars = query.split("&");
    let first = true;
    for(let iv = 0; iv < vars.length; iv++) {
        let part = vars[iv];
        const pair = part.split("=");
        if (decodeURIComponent(pair[0]) === param) {
            if (override || !pair[0]) {
                part = pv(param, value);
                // Skip duplicates
                value = undefined;
            }
        }
        if(part) {
            result += sp("&", !first, part);
            first = false;
        }
    }
    if(value) {
        result += sp("&", !first, pv(param, value));
    }
    if(result.length === iq + 1) {
        result = result.substring(0, iq);
    }
    return result;
}



// WEBPACK FOOTER //
// ./Scripts/React/Component/url.ts